import { ReactNode, useContext, useRef } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { Tooltip } from "primereact/tooltip";

import styles from "./SidebarNavLink.module.css";
import { selectAuthUser } from "../../../features/auth/authSlice";
import { routes } from "../../routing/routes";
import { canAccess } from "../../../features/auth/utils";
import { LayoutContext } from "./LayoutContext";

interface SidebarNavLinkProps {
  path: string;
  icon?: string;
  text?: ReactNode | string;
}

export default function SidebarNavLink({ path, icon, text }: SidebarNavLinkProps) {
  const { sidebarIsCollapsed } = useContext(LayoutContext);
  const authUser = useSelector(selectAuthUser);
  const navLinkRef = useRef(null);

  const requiredPrivilege = Object.values(routes).find((route) => route.path === path)!.requiredPrivilege;
  if (!canAccess(requiredPrivilege, authUser?.privilege)) {
    return null;
  }

  return (
    <>
      <NavLink
        ref={navLinkRef}
        className={({ isActive }) =>
          `${styles.link} ${isActive ? styles.linkActive : "text-color"} flex align-items-center mt-2 pl-2 py-1 text-lg no-underline`
        }
        to={path}
      >
        {icon && <i className={`pi ${icon} mr-2`} />}
        {!sidebarIsCollapsed && text}
        {sidebarIsCollapsed && <Tooltip target={navLinkRef} content={text} position="right" />}
      </NavLink>
    </>
  );
}
